<template>
  <div class="side game-int">
    <div class="h-tt"><h2>游戏介绍</h2></div>
    <div class="box">
      <dl v-for="(item, i) in list" :key="i">
        <dt>{{ item.title }}</dt>
        <dd v-for="intro in item.game_intro || []" :key="intro.id">
          <a
            href="javascript:;"
            @click="
              $router.push(
                `/game-offical/${$route.params.game_id}/notice/${intro.id}`
              )
              reportClick(item.title, intro.title, intro.id)
            "
            >{{ intro.title }}</a
          >
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  mounted() {
    this.$xlaGamePush('home_game_introduce_module_show')
  },
  methods: {
    reportClick(click_area, text, notice_id) {
      this.$xlaGamePush('home_game_introduce_module_click', {
        click_area,
        text,
        notice_id
      })
    }
  }
}
</script>
